import { render } from "./assessementTabs.vue?vue&type=template&id=b81e6b9a&scoped=true"
import script from "./assessementTabs.vue?vue&type=script&lang=js"
export * from "./assessementTabs.vue?vue&type=script&lang=js"

import "./assessementTabs.vue?vue&type=style&index=0&id=b81e6b9a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81e6b9a"]])

export default __exports__